import {Box, styled} from '@mui/material';
import TalentBridgeDetailBanner from './TalentBridgeDetailBanner';
import TalentBridgeListing from './TalentBridgeListing';
import {useEffect, useState} from 'react';
import {DriveBanner, getNewDriveBannerData} from '../utils';

type TalentBridgeDetailProps = {
  city: string;
};

const TalentBridgeDetail = ({city}: TalentBridgeDetailProps) => {
  const [driveBannerObj, setDriveBannerObj] = useState<DriveBanner | null>(
    null
  );
  useEffect(() => {
    const fetchData = async () => {
      const driveBannerData = await getNewDriveBannerData(city);
      setDriveBannerObj(driveBannerData);
    };
    fetchData();
  }, []);

  /* eslint-disable @typescript-eslint/no-explicit-any */
  const PageContentWrapper = styled('div')(({theme}) => ({
    width: '100%',
    height: '100%',

    zIndex: 5,
    position: 'relative',
    top: 0,
    marginBottom: true ? '0px' : '0',
    [theme.breakpoints.up('md')]: {
      marginBottom: '0px',
    },

    [theme.breakpoints.up('md')]: {
      '&::before': {
        height: '450px', // Adjust for larger screens
      },
    },
  }));

  if (!driveBannerObj) return null;
  return (
    <Box>
      <PageContentWrapper>
        <TalentBridgeDetailBanner driveBannerObj={driveBannerObj} />
        <TalentBridgeListing driveBannerObj={driveBannerObj} />
      </PageContentWrapper>
    </Box>
  );
};

export default TalentBridgeDetail;
